<template>
  <div id="modalCreateEditUser" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Usuário</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-1">
            <div class="row g-3">
              <div class="col-sm-6">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.name.$errors.length }"
                  placeholder="Nome Completo"
                  v-model="v$.user.name.$model"
                />
                <span
                  v-if="v$.user.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.user.name.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.user.name.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">Chapa:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Chapa"
                  v-model="user.chapa"
                />
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Cargo: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.user.roleId.$errors.length }"
                  v-model="v$.user.roleId.$model"
                >
                  <option value="">Selecione um cargo</option>
                  <option
                    v-for="role in roles"
                    :key="role.id"
                    :value="role.id"
                    :title="role.description"
                  >
                    {{ role.name }}
                  </option>
                </select>
                <span
                  v-if="v$.user.roleId.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">Telefone:</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.phone.$errors.length }"
                  placeholder="(00) 98888-8888"
                  v-model="v$.user.phone.$model"
                  v-maska="['(##) ####-####', '(##) #####-####']"
                />
                <span
                  v-if="v$.user.phone.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de telefone inválido <br />
                  Ex: (00) 98888-8888 / (00) 8888-8888
                </span>
              </div>
              <hr class="mb-0" />
              <div class="col-sm-6">
                <p>
                  Forma de Autenticação: <span class="text-danger">*</span>
                  <span
                    role="button"
                    class="ph-question ms-1"
                    title="Clique para visualizar a dica"
                    @click="
                      showInfoFormAuthentication = !showInfoFormAuthentication
                    "
                  />
                </p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="byEmail"
                    value="1"
                    v-model="user.formAuthentication"
                  />
                  <label class="form-check-label" for="byEmail"> E-mail </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="byNickname"
                    value="2"
                    v-model="user.formAuthentication"
                  />
                  <label class="form-check-label" for="byNickname">
                    Nome de Usuário
                  </label>
                </div>
              </div>
              <div v-if="user.formAuthentication === '1'" class="col-sm-6">
                <label class="form-label">
                  E-mail: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.email.$errors.length }"
                  placeholder="usuario@email.com.br"
                  v-model="v$.user.email.$model"
                />
                <span
                  v-if="v$.user.email.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.user.email.email.$invalid"
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div v-if="user.formAuthentication === '2'" class="col-sm-6">
                <label class="form-label">
                  Nome de Usuário: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.nickname.$errors.length }"
                  placeholder="Nome de Usuário"
                  v-model="v$.user.nickname.$model"
                />
                <span
                  v-if="v$.user.nickname.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div v-if="showInfoFormAuthentication" class="col-sm-12">
                <div
                  class="alert alert-primary alert-dismissible fade show border-0 p-2 mb-0"
                >
                  <p>
                    As formas de autenticação são utilizando
                    <strong>e-mail</strong> ou <strong>nome de usuário</strong>.
                  </p>
                  <p>
                    Se for selecionado <strong>e-mail</strong>, os dados de
                    acesso serão enviado para o e-mail informado.
                  </p>
                  <p class="mb-1">
                    Se for selecionado <strong>nome de usuário</strong>, você
                    deve criar uma senha para o usuário a ser cadastrado.
                  </p>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="alert"
                    title="Fechar"
                    @click="
                      showInfoFormAuthentication = !showInfoFormAuthentication
                    "
                  />
                </div>
              </div>
              <div
                v-if="!userId && user.formAuthentication === '2'"
                class="col-sm-6"
              >
                <label class="form-label">
                  Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.password.$errors.length }"
                  placeholder="Senha"
                  v-model="v$.user.password.$model"
                />
                <span
                  v-if="v$.user.password.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.user.password.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O senha deve possuir pelo menos
                  {{ v$.user.password.minLength.$params.min }} caracteres
                </span>
              </div>
              <div
                v-if="!userId && user.formAuthentication === '2'"
                class="form-group col-sm-6"
              >
                <label class="form-label">
                  Confirme a Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.user.confirmPassword.$errors.length,
                  }"
                  placeholder="Confirme a Senha"
                  v-model.trim="v$.user.confirmPassword.$model"
                />
                <span
                  v-if="v$.user.confirmPassword.sameAsPassword.$invalid"
                  class="invalid-feedback"
                >
                  As senhas devem ser idênticas
                </span>
              </div>
              <hr class="mb-0" />
              <div class="col-sm-6">
                <p>
                  Usuário Admin: <span class="text-danger">*</span>
                  <span
                    class="ph-question ms-1"
                    title="Pode cadastrar cargos, usuários e cursos"
                  />
                </p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="isAdminNo"
                    value="0"
                    v-model="user.isAdmin"
                  />
                  <label class="form-check-label" for="isAdminNo"> Não </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="isAdminYes"
                    value="1"
                    v-model="user.isAdmin"
                  />
                  <label class="form-check-label" for="isAdminYes"> Sim </label>
                </div>
              </div>
              <div v-if="userId" class="col-sm-6">
                <p>Status: <span class="text-danger">*</span></p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="statusInativo"
                    value="0"
                    v-model="user.status"
                  />
                  <label class="form-check-label" for="statusInativo">
                    Inativo
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="statusAtivo"
                    value="1"
                    v-model="user.status"
                  />
                  <label class="form-check-label" for="statusAtivo">
                    Ativo
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  sameAs,
} from '@vuelidate/validators'
import { maska } from 'maska'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditUserModal',

  props: {
    userId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  directives: { maska },

  data() {
    return {
      user: {
        name: '',
        chapa: '',
        roleId: '',
        phone: '',
        formAuthentication: '',
        email: '',
        nickname: '',
        isAdmin: '',
        password: '',
        confirmPassword: '',
      },
      showInfoFormAuthentication: false,
      roles: [],
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.userId ? 'Atualizar' : 'Cadastrar'
    },
  },

  watch: {
    'user.formAuthentication': {
      handler(newVal, oldVal) {
        if (!this.userId) {
          if (newVal === '1') {
            this.user.nickname = ''
            this.user.password = ''
            this.user.confirmPassword = ''
          } else if (newVal === '2') {
            this.user.email = ''
          }
        }
      },
    },
  },

  methods: {
    async getRoles() {
      try {
        this.roles = await this.$store.dispatch('getRoles')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getUser() {
      try {
        this.user = await this.$store.dispatch('getUser', this.userId)
        showModal('modalCreateEditUser')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.userId) {
            response = await this.$store.dispatch('updateUser', this.user)
          } else {
            response = await this.$store.dispatch('saveUser', this.user)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      user: {
        name: {
          required,
          minLength: minLength(8),
        },
        roleId: {
          required,
        },
        phone: {
          minLength: minLength(14),
          maxLength: maxLength(15),
        },
        formAuthentication: {
          required,
        },
        email: {
          required: requiredIf(() => {
            if (this.user.formAuthentication === '1') {
              return true
            }
            return false
          }),
          email,
        },
        nickname: {
          required: requiredIf(() => {
            if (this.user.formAuthentication === '2') {
              return true
            }
            return false
          }),
        },
        isAdmin: {
          required,
        },
        password: {
          required: requiredIf(() => {
            if (!this.user.id && this.user.formAuthentication === '2') {
              return true
            }
            return false
          }),
          minLength: minLength(6),
        },
        confirmPassword: {
          sameAsPassword: sameAs(this.user.password),
        },
      },
    }
  },

  mounted() {
    this.getRoles()
    if (this.userId) {
      this.getUser()
    } else {
      showModal('modalCreateEditUser')
    }
  },
}
</script>
